import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { errorHandler, getContent } from '../../util/responseUtil';
import { STATUS_TICKET_CONSTANT } from '../../constants/statusTicketConstant';
import { ROUTER_CONSTANT } from '../../constants/routerConstant';
import API_TICKET_LIST from '../../api/apiTicketList';
import ActionType from '../../redux/reducer/globalActionType';
import { CheckPermissionComponent } from '../../util/permission';
import {
    TICKET_LIST_ALL_CHAT_HISTORY_VIEW,
    TICKET_LIST_ALL_CHAT_HISTORY_VIEW_ASSIGNEE
} from '../../constants/menuPermissionConstant';

class TicketExportChat extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fileLink: ''
        }
    }

    getDataHistoryChat = () => {
        API_TICKET_LIST.getDataHistoryChat(this.props.data.id, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        fileLink: getContent(res).file_link
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    checkStatusTicket = () => {
        if (this.props.data.status === STATUS_TICKET_CONSTANT.IN_PROGRESS && window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_ALL)) return true;
        if (this.props.data.status === STATUS_TICKET_CONSTANT.RESOLVED) return true;
        if (this.props.data.status === STATUS_TICKET_CONSTANT.CLOSED) return true;
        if (this.props.data.status === STATUS_TICKET_CONSTANT.UNDER_OBSERVATION) return true;
        return false;
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentDidUpdate(prevProps) {
        if (this.props.data.id !== prevProps.data.id) {
            this.getDataHistoryChat();
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[TICKET_LIST_ALL_CHAT_HISTORY_VIEW, TICKET_LIST_ALL_CHAT_HISTORY_VIEW_ASSIGNEE]} userPermission={this.props.userDetail.permissions}>
                <button type="button" id="btnexportchat" className={this.checkStatusTicket() && this.state.fileLink ? "bg-white text-darkblue flex items-center rounded-lg focus:outline-none py-2 px-5 mx-1 relative" : "hidden"} onClick={() => window.open(this.state.fileLink)}>
                    <span className="mx-1">Ekspor Chat</span>
                </button>
            </CheckPermissionComponent >
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TicketExportChat));